"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GHE_THROTTLED = void 0;
/**
 * Error code for a GHE call that was still `throttled` after retries were
 * exhausted. Defined once here — never re-declared as a per-Lambda string
 * literal — so every producer (a step that gives up retrying) and consumer
 * (anything branching on `StepError.code`) agree on the exact same value.
 */
exports.GHE_THROTTLED = 'GHE_THROTTLED';
//# sourceMappingURL=step-functions.js.map